module.exports.steveAddons = {
	rootLevel: require("./src/app/addons/RootUserFeedback")
};
module.exports.modalUserFeedback = require("./src/app/UserFeedbackComponent");